import React, {useContext, useEffect} from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import {Select} from "@mui/material";
import firebase from "../../firebase/firebase";
import MenuItem from "@mui/material/MenuItem";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import InputBase from "@mui/material/InputBase";
import DownloadFileHelper from "../../components/download-file-helper";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';
import Paper from "@mui/material/Paper";
import {useNavigate} from "react-router-dom";
import PostNotification from "../../helpers/post-notification";
import {AuthUserContext} from "../../providers/AuthProvider";
import PostActivity from "../../helpers/post-activity";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#F1F4F8',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 30,
    position: 'relative',
    backgroundColor: '#204488',
    border: 'none',
    fontSize: 16,
    width: 80,
    color: '#fff',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 30,
      borderColor: 'none',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

export default function ManageProjectContracts({contarctList, project}){
  const {profile} = useContext(AuthUserContext);

  const navigator = useNavigate()

  useEffect(() => {
    setNdaList(contarctList)
  }, [contarctList])
  const [ndaLists, setNdaList] = React.useState([])
  return (
    <TableContainer >
      <Table sx={{ minWidth: 700 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16, }}>User type</StyledTableCell>
            <StyledTableCell  align="center"  sx={{fontWeight: 'bolder', fontSize:16, }}>Name</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Profile</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Documentation</StyledTableCell>
            <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>

          {ndaLists?.length > 0 && ndaLists.map((row, i) => (
            <>

            {row.signContract && Object.keys(row.signContract).map((key) => {

              return (
                <StyledTableRow
                  key={row.id+key}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <StyledTableCell  component="th" scope="row"><Typography noWrap={true}>{key}</Typography></StyledTableCell>
                  <StyledTableCell   align="center">
                    <Typography noWrap={true} >
                      {key === 'creator' ? row.creator && row.creator.name : row.name}
                    </Typography>

                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Button variant={'text'} color={'primary'} sx={{textDecoration: 'underline'}} onClick={() => navigator('/admin/user-details/' + row?.uid)}>View</Button>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Stack direction={'row'} component={Paper} spacing={2}  justifyContent="center"
                           alignItems="center" sx={{maxWidth: 200, margin: 'auto',py:1, px:2}}>
                      <InsertDriveFileIcon sx={{color: row?.signContract[key].split('.')[1] === 'pdf' ? 'red' : 'gray'}}/>
                      <Typography noWrap={true} sx={{maxWidth:150,  }}>{  row?.signContract[key].split('/')[ row?.signContract[key].split('/').length -1]}</Typography>
                      <IconButton size={'small'} color={"primary"} onClick={() => DownloadFileHelper(row?.signContract[key])}>
                        <DownloadForOfflineRoundedIcon></DownloadForOfflineRoundedIcon>
                      </IconButton>
                    </Stack>

                  </StyledTableCell>
                  <StyledTableCell align="center">

                    <Select value={row?.contractStatus && row?.contractStatus[key] ? row?.contractStatus[key] : 'pending'} 
                     style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",paddingLeft:"10px",paddingRight:"10px",width:"172px",height:"50px"}}
                      IconComponent={() => <ArrowDropDownIcon  />}
                    multiple={false} onChange={(e) => {
                      const p = [...ndaLists];
                      p[i].contractStatus = row?.contractStatus || {}
                      p[i].contractStatus[key] = e.target.value
                      debugger
                      setNdaList(p)
                      firebase
                        .firestore()
                        .collection('contracts')
                        .doc(row?.id)
                        .update({contractStatus: p[i].contractStatus})
                        .then()
                     if (e.target.value === 'approved') {
                       PostNotification({
                         title: 'Documentation For Singed Contract',
                         text: 'We are excited to inform that the admin approved the signed Contract. Click here to continue.',
                         uid: key === 'investor' ? row.uid : row.creator && row.creator.id,
                         createdBy:profile?.uid,
                         popup: true,
                         contractId: row.id,
                         projectId: row.projectId,
                       }).then((id) => console.log(id));
                       debugger
                       PostActivity({
                         text: `"${profile.name}" ${profile?.super === true && 'super admin'}
                          has approved "${row?.userType === 'creator' ? row.name : row.name}" ${row?.userType === 'creator' ? "creator's" : "investor's"}
                            contract for "${project?.title}" project`,
                         uid: profile.uid,
                         createdBy:profile?.uid
                       }).then()
                     }


                    }}>

                      <MenuItem value={'pending'}>
                        Pending
                      </MenuItem>
                      <MenuItem value={'approved'}>
                        Approved
                      </MenuItem>
                      <MenuItem value={'rejected'}>
                        Rejected
                      </MenuItem>
                    </Select></StyledTableCell>
                </StyledTableRow>


              )

            })}

            </>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
